const selfProducesChecklists = [
    {
        "category": "01",
        "text": "1.環境",
        "display": "環境",
        "opinionAndSuggestion": "",
        "items": [
            {
                "code": "01-1",
                "text": "1.1 查驗過程中，受訪人是否全程在場？\n" +
                    "受訪人姓名及職稱："
            },
            {
                "code": "01-2",
                "text": "1.2 經營者是否同時進行有機與非有機的加工作業？"
            },
            {
                "code": "01-3",
                "text": "1.3 自產農產加工（廠）場周圍是否有有害氣體、輻\n" +
                    " 射性物質、擴散性污染源、垃圾場及有害生物存\n" +
                    "在污染問題？"
            }
        ]
    },
    {
        "category": "02",
        "text": "2.標示及產品成分",
        "display": "標示及產品成分",
        "opinionAndSuggestion": "",
        "items": [
            {
                "code": "02-1",
                "text": "2.1 標示及產品成分”內容是否正確？"
            },
            {
                "code": "02-2",
                "text": "2.2 成品標籤上是否有”有效日期” 或“可追蹤產品批號”？"
            },
            {
                "code": "02-3",
                "text": "2.3 您查該產品的同一種原料中是否未混合使用有機和非有機來源者？"
            }
        ]
    },
    {
        "category": "03",
        "text": "3.建築設施與衛生安全管理",
        "display": "建築設施與衛生安全管理",
        "opinionAndSuggestion": "",
        "items": [
            {
                "code": "03-1",
                "text": "3.1 作業場所之天花板、牆壁、地面是否清潔？"
            },
            {
                "code": "03-2",
                "text": "3.2 加工調理、包裝場所及工作檯面是否清潔？"
            },
            {
                "code": "03-3",
                "text": "3.3 工作人員調理不經加熱的即食食品是否穿戴頭罩、口罩、手套？"
            },
            {
                "code": "03-4",
                "text": "3.4 工作中是否有吸煙、飲食、嚼口香糖等不當行為？"
            },
            {
                "code": "03-5",
                "text": "3.5 工作人員患有傳染病、手部皮膚病、外傷時，是否從事與食品接觸的工作？"
            },
            {
                "code": "03-6",
                "text": "3.6 即食內包裝工作人員是否年定期接受健康檢查（例：法規要求之項目如A型肝炎IgM、IgG、肺結核…）【產品為不經加熱之即食食品適用】？"
            }
        ]
    },
    {
        "category": "04",
        "text": "4.製程管理及有機完整性的確保",
        "display": "製程管理及有機完整性的確保",
        "opinionAndSuggestion": "",
        "items": [
            {
                "code": "04-1",
                "text": "4.1 所使用之設備、容器與器具是否作避免污染食品之措施？"
            },
            {
                "code": "04-2",
                "text": "4.2 不經加熱的即食食品在製程中是否與地面直接接觸？"
            },
            {
                "code": "04-3",
                "text": "4.3 加工、包裝之設備、器具、容器及管線等，是否清洗乾淨？"
            },
            {
                "code": "04-4",
                "text": "4.4 產品正式生產流程圖與現場製程是否符合？"
            },
            {
                "code": "04-5",
                "text": "4.5 如使用同一套設備於有機與非有機產品之製造加工，經營者是否採取防範措施以維護有機之完整性？"
            },
            {
                "code": "04-6",
                "text": "4.6 所有的包裝材料是否皆符合食品衛生安全及品質之標準？"
            },
            {
                "code": "04-7",
                "text": "4.7 包裝材料儲存場所是否保持清潔及衛生，避免產品受污染？"
            },
            {
                "code": "04-8",
                "text": "4.8 如有機、轉型期與非有機產品儲藏在同一地方，是否有明確的識別標示？"
            },
            {
                "code": "04-9",
                "text": "4.9 有機、轉型期產品於儲藏過程中是否未受到其他物質污染？"
            },
            {
                "code": "04-10",
                "text": "4.10 儲藏場所是否乾淨、衛生、明亮，並可防止有害生物進入或無有害物質殘留？"
            },
            {
                "code": "04-11",
                "text": "4.11 進貨時，經營者是否自行運送？"
            },
            {
                "code": "04-12",
                "text": "4.12 請說明成品出貨的模式："
            },
            {
                "code": "04-13",
                "text": "4.13 其他說明"
            }
        ]
    },
    {
        "category": "05",
        "text": "5.有害生物防治",
        "display": "有害生物防治",
        "opinionAndSuggestion": "",
        "items": [
            {
                "code": "05-1",
                "text": "5.1 經營者之有害生物防治管理計劃是否包含了預防性、機械性、物理性或生物性的控制措施？\n" +
                    "其他說明"
            },
            {
                "code": "05-2",
                "text": "5.2 使用“有害生物防治資材”時，是否採取任何防範措施以避免與有機產品、原料或包裝材料接觸？"
            },
            {
                "code": "05-3",
                "text": "5.3 經營者是否保存“有害生物防治措施”的紀錄？如“否”，請說明："
            }
        ]
    },
    {
        "category": "06",
        "text": "6.紀錄的保持與回朔",
        "display": "紀錄的保持與回朔",
        "opinionAndSuggestion": "",
        "items": [
            {
                "code": "06-1",
                "text": "6.1 銷售紀錄是否完整？"
            },
            {
                "code": "06-2",
                "text": "6.2 保存有關產品及相關標準要求之符合性所有抱怨紀錄，並隨時提供查閱？"
            },
            {
                "code": "06-3",
                "text": "6.3 對於會影響符合驗證要求之產品所發現之任何缺失及抱怨，是否採取適當之因應措施？"
            },
            {
                "code": "06-4",
                "text": "6.4 其他說明"
            }
        ]
    },
]

export default selfProducesChecklists;